export {};

export function gaEventsCustomParamGetTripType(type: number) {
  try {
    switch (type) {
      case 1:
        return "Oneway";
      case 2:
        return "Roundtrip";
      case 3:
        return "Multicity";
    }
  } catch {
    return "";
  }
}
export function gaEventsCustomParamGetFlightClassType(type: string) {
  try {
    switch (type) {
      case "E":
        return "Economy";
      case "B":
        return "Business";
      case "P":
        return "Premium Economy";
      case "F":
        return "First Class";
      default:
        return "Economy";
    }
  } catch {
    return "";
  }
}

export function gaEventsCustomParamGetSelectedFlightDetails(bookingDetails: any, showExtraParams = false) {
  try {
    if (showExtraParams)
      return {
        flight_departure: bookingDetails?.airPort?.[0]?.departureDate,
        flight_origin_code: bookingDetails?.airPort?.[0]?.departure,
        flight_destination_code: bookingDetails?.airPort?.[0]?.arrival,
        flight_trip_type: gaEventsCustomParamGetTripType(bookingDetails?.tripType),
        flight_cabin_class: gaEventsCustomParamGetFlightClassType(bookingDetails?.flightClass),
        flight_destination_name_clean: bookingDetails?.airPort?.[0]?.arrivalCityAddress?.split?.(",")?.[0] || bookingDetails?.airPort?.[0]?.arrival || "",
        flight_origin_name_clean: bookingDetails?.airPort?.[0]?.departureCityAddress?.split?.(",")?.[0] || bookingDetails?.airPort?.[0]?.departure || "",
        // `?? 0` per addend: an undefined count makes the sum NaN, which serialises
        // to `null` on the wire → Ariadne reads `flight_travellers` as missing.
        flight_travellers:
          (bookingDetails?.adultsCount ?? 0) +
          (bookingDetails?.seniorsCount ?? 0) +
          (bookingDetails?.childrenCount ?? 0) +
          (bookingDetails?.infantCount ?? 0) +
          (bookingDetails?.infantLapCount ?? 0),

        flight_origin_name: bookingDetails?.airPort?.[0]?.departureAirportFullName,
        flight_destination_name: bookingDetails?.airPort?.[0]?.arrivalAirportFullName,
        flight_return: bookingDetails?.tripType === 2 ? bookingDetails?.airPort?.[1]?.departureDate : "",
      };
    return {
      flight_departure: bookingDetails?.airPort?.[0]?.departureDate,
      flight_origin_code: bookingDetails?.airPort?.[0]?.departure,
      flight_destination_code: bookingDetails?.airPort?.[0]?.arrival,
      flight_trip_type: gaEventsCustomParamGetTripType(bookingDetails?.tripType),
      flight_cabin_class: gaEventsCustomParamGetFlightClassType(bookingDetails?.flightClass),
      flight_destination_name_clean: bookingDetails?.airPort?.[0]?.arrivalCityAddress?.split?.(",")?.[0] || bookingDetails?.airPort?.[0]?.arrival || "",
      flight_origin_name_clean: bookingDetails?.airPort?.[0]?.departureCityAddress?.split?.(",")?.[0] || bookingDetails?.airPort?.[0]?.departure || "",
      // `?? 0` per addend: an undefined count makes the sum NaN, which serialises
      // to `null` on the wire → Ariadne reads `flight_travellers` as missing.
      flight_travellers:
        (bookingDetails?.adultsCount ?? 0) +
        (bookingDetails?.seniorsCount ?? 0) +
        (bookingDetails?.childrenCount ?? 0) +
        (bookingDetails?.infantCount ?? 0) +
        (bookingDetails?.infantLapCount ?? 0),
    };
  } catch {
    return {};
  }
}

// `selectedHotel` is the actual hotel the user is acting on (the enriched search-result
// object from `hotelData.data[cityIndex].hotels[]` — carries a backend-sourced ISO
// `country` plus `checkIn`/`checkOut`/`city` enriched from the selected city group).
// Prefer it over `bookingDetails.hotels[0]`, which is the LLM-derived search INPUT:
// its `country` is often empty (filled async via Google Places), its `checkIn` is
// blanked for past dates, and `[0]` is always the FIRST city — wrong for multi-city
// trips where the user is booking a later city. Falls back to `hotels[0]` for callers
// that don't pass a selected hotel.
export function gaEventsCustomParamGetSelectedHotelDetails(bookingDetails: any, selectedHotel?: any) {
  try {
    const hotel = selectedHotel ?? bookingDetails?.hotels?.[0];
    return {
      stay_checkin: hotel?.checkIn,
      stay_checkout: hotel?.checkOut,
      stay_location:
        hotel?.city || hotel?.hotelInformation?.city || hotel?.hotelDetails?.city || "",
      // ISO country code sits at the top level on a search-result hotel, but is
      // nested under `hotelDetails`/`hotelInformation` on the post-booking /
      // modify-hotel shapes — resolve all three so the key is never dropped.
      // Final `"XX"` fallback is load-bearing: `triggerGAEvent`'s removeEmptyKeys
      // strips any undefined/"" value, and the downstream Mailchimp uploader
      // (Ariadne) REQUIRES stay_country_code to be present for `select stays` /
      // `search stays` events — a dropped key throws "payload missing
      // 'stay_country_code' key". "XX" is ISO 3166-1's reserved "unknown" code;
      // do NOT use "NA" here (that's Namibia and would pollute country segments).
      stay_country_code:
        hotel?.country || hotel?.hotelDetails?.country || hotel?.hotelInformation?.country || "XX",
      // `?? 0` per addend: any undefined count makes the whole sum NaN, which
      // JSON-serialises to `null` on the wire → Ariadne reads it as a missing
      // `stay_travellers`. 0 is a valid, non-polluting count.
      stay_travellers:
        (bookingDetails?.adultsHotelCount ?? 0) +
        (bookingDetails?.seniorsHotelCount ?? 0) +
        (bookingDetails?.childrenHotelCount ?? 0) +
        (bookingDetails?.infantHotelCount ?? 0),
    };
  } catch {
    return {};
  }
}

export function gaEvetnsCustomParamGetHotelPrice(hotelData: any, hotelId: string) {
  try {
    const hotel = hotelData?.data?.[0]?.hotels?.find((hotel: any) => hotel?.hotelId === hotelId);
    return hotel?.totalPrice?.actualPrice || "";
  } catch {
    return "";
  }
}
